import { Flex, Textarea } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import CustomReactSelect from "../../../general/form/CustomReactSelect";

const navFrequencyOptions = [
  { value: "Monthly", label: "Monthly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Semi-annually", label: "Semi-annually" },
  { value: "Annually", label: "Annually" },
];

const fundTermOptions = [
  { value: "5-7 years", label: "5-7 years" },
  { value: "7-9 years", label: "7-9 years" },
  { value: "9-12 years", label: "9-12 years" },
];

const investmentPeriodOptions = [
  { value: "2", label: "2 years" },
  { value: "3", label: "3 years" },
  { value: "4", label: "4 years" },
  { value: "5", label: "5 years" },
];


const OnboardingStep23 = ({ formData, handleChange }) => {
 

  const handleSelectChange = (fieldName) => (selectedOption) => {
    handleChange({
      target: { name: fieldName, value: selectedOption?.value },
    });
  };

  
  return (
    <>
      <Flex direction="column" gap={8}>
        <h6>Operational setup</h6>

        <Flex direction="column">


        <Fieldset
          flex={1}
          label="NAV Frequency"
          description="Select the NAV frequency for the fund."
          input={
            <CustomReactSelect
              name="navFrequency"
              placeholder="Choose NAV frequency"
              options={navFrequencyOptions}
              value={navFrequencyOptions.find((option) => option.value === formData.navFrequency)}
              onChange={handleSelectChange("navFrequency")}
            />
          }
        />

        {/* Expected Fund Term */}
        <Fieldset
          flex={1}
          label="Expected Fund Term"
          description="Select the expected fund term. Leave blank if unknown."
          input={
            <CustomReactSelect
              name="expectedFundTerm"
              placeholder="Choose expected fund term"
              options={fundTermOptions}
              value={fundTermOptions.find((option) => option.value === formData.expectedFundTerm)}
              onChange={handleSelectChange("expectedFundTerm")}
            />
          }
        />

        {/* Investment Period */}
        <Fieldset
          flex={1}
          label="Investment Period"
          description="Select the investment period in years."
          input={
            <CustomReactSelect
              name="investmentPeriod"
              placeholder="Choose investment period"
              options={investmentPeriodOptions}
              value={investmentPeriodOptions.find((option) => option.value === formData.investmentPeriod)}
              onChange={handleSelectChange("investmentPeriod")}
            />
          }
        />

        {/* Expected Liquidation Period */}
        <Fieldset
          flex={1}
          label="Expected Liquidation Period"
          description="Provide any specific details regarding the expected liquidation period."
          input={
            <Textarea
              name="expectedLiquidationPeriod"
              placeholder="Enter liquidation period details"
              value={formData.expectedLiquidationPeriod || ""}
              onChange={(e) => handleChange(e)}
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "1rem",
                borderColor: "#CBD5E0",
                borderRadius: "4px",
                minHeight: "80px",
              }}
            />
          }
        />
        
       

        </Flex>
      </Flex>

      
    </>
  );
};

export default OnboardingStep23;
